import { FieldName } from 'react-hook-form';

import { ICD10Disease } from '@dreryk/egabinet-icd-dictionary-frontend-api';

import { Bean, FieldControllerProps, ValidationRules } from '@dreryk/react-common';
import { Autosuggest, AutosuggestOnSelectionChange, FormLabel, TestId } from '@dreryk/react-components';

import { interactiveTableKeys } from '../../translations';

import { diseaseLabelExtractor, itemRenderer, searchCreator } from './DiseaseAutosuggest.utils';

type DiseaseAutosuggestProps<NAME extends string> = FieldControllerProps<NAME, ICD10Disease | null> & {
   readonly dictionaryValidOn: Date;
   readonly defaultItems?: ICD10Disease[];
   readonly onSelectionChange?: AutosuggestOnSelectionChange<ICD10Disease>;
   readonly validationRules?: ValidationRules<Bean>;
   readonly className?: string;
   readonly testId: TestId;
};

export const DiseaseAutosuggest = <NAME extends string>(props: DiseaseAutosuggestProps<NAME>): JSX.Element => {
   return (
      <Autosuggest<ICD10Disease>
         testId={props.testId}
         controller={props.register(
            props.name as FieldName<{ [key in NAME]: ICD10Disease | null }>,
            props.validationRules
         )}
         keyProperty={'code'}
         label={
            <FormLabel
               testId={'label'}
               label={interactiveTableKeys.autosuggest.label}
               required={Boolean(props.required || props.validationRules?.required)}
            />
         }
         placeholder={interactiveTableKeys.autosuggest.placeholder}
         horizontal={false}
         defaultValue={props.defaultValue}
         defaultItems={props.defaultItems}
         searchCreator={searchCreator(props.dictionaryValidOn)}
         itemRenderer={itemRenderer}
         onSelectionChange={props.onSelectionChange}
         minChars={2}
         className={props.className}
         labelExtractor={diseaseLabelExtractor}
      />
   );
};
